import React, { useState, useEffect } from 'react';
import './PayrollTable.css';
import './ShiftGrid.css';

const API = '/api/payroll';

const SHIFT_OPTIONS = [
  { value: '',     label: '—',     hint: '',                                 color: '' },
  { value: 'д',    label: 'день',  hint: 'Дневная смена (ставка / 2)',       color: '#d1fae5', text: '#065f46' },
  { value: '0.5',  label: 'полсм', hint: 'Полсмены (ставка / 4)',            color: '#fef3c7', text: '#92400e' },
  { value: 'н',    label: 'ночь',  hint: 'Ночная смена (ставка / 2)',        color: '#e0e7ff', text: '#3730a3' },
  { value: 'с',    label: 'сутки', hint: 'Суточная смена (полная ставка)',   color: '#1e3a5f', text: '#ffffff' },
  { value: 'дст',  label: 'дст',   hint: 'Стажёр день (ставка/2 − 30%)',    color: '#fde68a', text: '#78350f' },
  { value: 'нст',  label: 'нст',   hint: 'Стажёр ночь (ставка/2 − 30%)',    color: '#c7d2fe', text: '#3730a3' },
  { value: 'сст',  label: 'сст',   hint: 'Стажёр сутки (ставка − 30%)',     color: '#374151', text: '#fbbf24' },
  { value: 'замд', label: 'замд',  hint: 'Замещение адм. день (100%+50%)',  color: '#fce7f3', text: '#9d174d' },
  { value: 'замн', label: 'замн',  hint: 'Замещение адм. ночь (100%+50%)',  color: '#fbcfe8', text: '#831843' },
  { value: 'замс', label: 'замс',  hint: 'Замещение адм. сутки (100%+50%)', color: '#f9a8d4', text: '#500724' },
  { value: 'х',    label: 'х',     hint: 'Выходной / отгул (0 ₽)',           color: '#fee2e2', text: '#991b1b' },
  { value: 'Н',    label: 'Н',     hint: 'Неявка / прогул (0 ₽)',            color: '#7f1d1d', text: '#fca5a5' },
];

const MONTHS = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
const DAY_NAMES = ['вс','пн','вт','ср','чт','пт','сб'];
const WEEKEND = [0, 6]; // вс, сб

export default function Shifts() {
  const now = new Date();
  const [hotels, setHotels]         = useState([]);
  const [depts, setDepts]           = useState([]);
  const [employees, setEmployees]   = useState([]);
  const [grid, setGrid]             = useState({}); // { empId_day: shiftValue }
  const [selectedHotel, setHotel]   = useState('');
  const [selectedDept, setDept]     = useState('');
  const [year, setYear]             = useState(now.getFullYear());
  const [month, setMonth]           = useState(now.getMonth());
  const [loading, setLoading]       = useState(false);
  const [popup, setPopup]           = useState(null);
  const [showLegend, setShowLegend] = useState(false); // { empId, day, x, y }
  const [history, setHistory]       = useState(null); // { shifts, loading }
  const [isAdmin] = useState(() => {
    try { return JSON.parse(localStorage.getItem('payroll_user'))?.role === 'superadmin'; } catch { return false; }
  });

  useEffect(() => { loadRefs(); }, []);
  useEffect(() => { if (selectedHotel || selectedDept) loadData(); }, [selectedHotel, selectedDept, year, month]);

  async function loadRefs() {
    const h = await fetch(`${API}/hotels-and-depts`).then(r => r.json());
    setHotels(Array.isArray(h) ? h : (h.hotels || []));
    setDepts(Array.isArray(h) ? [] : (h.departments || []));
  }

  async function loadData() {
    setLoading(true);
    const dateFrom = `${year}-${String(month+1).padStart(2,'0')}-01`;
    const lastDay  = new Date(year, month+1, 0).getDate();
    const dateTo   = `${year}-${String(month+1).padStart(2,'0')}-${lastDay}`;

    const params = selectedHotel
      ? `hotel_id=${selectedHotel}`
      : `department_id=${selectedDept}`;

    const [emps, shifts] = await Promise.all([
      fetch(`${API}/employees?${params}`).then(r => r.json()),
      fetch(`${API}/shifts?${params}`).then(r => r.json()),
    ]);

    setEmployees(Array.isArray(emps) ? emps : []);

    // Строим grid из загруженных смен
    const g = {};
    (Array.isArray(shifts) ? shifts : []).forEach(s => {
      const d = new Date(s.work_date);
      if (d.getFullYear() === year && d.getMonth() === month) {
        const key = `${s.employee_id}_${d.getDate()}`;
        // Используем shift_type для отображения
        g[key] = s.shift_type || (s.shift_count === 0 ? 'х' : s.shift_count === 0.5 ? '0.5' : '1');
      }
    });
    setGrid(g);
    setLoading(false);
  }

  const daysInMonth = new Date(year, month+1, 0).getDate();
  const days = Array.from({ length: daysInMonth }, (_, i) => i+1);

  const CATEGORY_GROUPS = [
    { key: 'manager', label: 'Управляющие' },
    { key: 'spir',    label: 'СПИР' },
    { key: 'admin',   label: 'Администраторы' },
    { key: 'maid',    label: 'Горничные' },
    { key: 'tech',    label: 'Техники' },
    { key: 'office',  label: 'Офис' },
    { key: 'ota',     label: 'ОТА' },
    { key: 'ob',      label: 'Отдел бронирования' },
  ];

  console.log('employees:', employees);
  const groupedEmployees = CATEGORY_GROUPS
    .map(g => ({ ...g, emps: employees.filter(e => e.category === g.key) }))
    .filter(g => g.emps.length > 0);

  function getDayName(day) {
    return DAY_NAMES[new Date(year, month, day).getDay()];
  }
  function isWeekend(day) {
    return WEEKEND.includes(new Date(year, month, day).getDay());
  }

  function cellClick(e, empId, day) {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    setPopup({ empId, day, x: rect.left, y: rect.bottom + window.scrollY });
    if (isAdmin) loadShiftHistory(empId, day);
  }

  async function loadShiftHistory(empId, day) {
    setHistory({ shifts: [], loading: true });
    const workDate = `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    const data = await fetch(`${API}/shifts?hotel_id=${selectedHotel}`).then(r => r.json());
    const dayShifts = (Array.isArray(data) ? data : []).filter(s => {
      const d = new Date(s.work_date);
      return s.employee_id === empId && d.getDate() === day && d.getMonth() === month && d.getFullYear() === year;
    });
    setHistory({ shifts: dayShifts, loading: false });
  }

  async function setShift(empId, day, value) {
    setPopup(null);
    const key = `${empId}_${day}`;
    const newGrid = { ...grid };

    if (!value) {
      delete newGrid[key];
      // Удаляем смену с сервера
      const shifts = await fetch(`${API}/shifts?hotel_id=${selectedHotel || ''}`).then(r => r.json());
      const existing = (Array.isArray(shifts) ? shifts : []).find(s => {
        const d = new Date(s.work_date);
        return s.employee_id === empId && d.getDate() === day && d.getMonth() === month && d.getFullYear() === year;
      });
      if (existing) await fetch(`${API}/shifts/${existing.id}`, { method: 'DELETE' });
    } else {
      newGrid[key] = value;
      const workDate = `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
      const shiftCount = (value === 'х' || value === 'Н') ? 0 : ['н','с','д','дст','нст','сст','замд','замн','замс'].includes(value) ? 1 : parseFloat(value) || 0;
      await fetch(`${API}/shifts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          employee_id: empId,
          hotel_id: selectedHotel ? parseInt(selectedHotel) : 1,
          work_date: workDate,
          shift_count: shiftCount,
          shift_type: value,
          note: value === 'н' ? 'ночь' : value === 'с' ? 'сутки' : value === 'х' ? 'выходной' : value === 'Н' ? 'неявка' : value === 'дст' ? 'стажёр день' : value === 'нст' ? 'стажёр ночь' : value === 'сст' ? 'стажёр сутки' : value === 'замд' ? 'замещение день' : value === 'замн' ? 'замещение ночь' : value === 'замс' ? 'замещение сутки' : '',
        }),
      });
    }
    setGrid(newGrid);
  }

  function getCellStyle(value) {
    const opt = SHIFT_OPTIONS.find(o => o.value === value);
    if (!opt || !opt.color) return {};
    return { background: opt.color, color: opt.text, fontWeight: 600 };
  }

  function getCellLabel(value) {
    const opt = SHIFT_OPTIONS.find(o => o.value === value);
    return opt ? opt.label : '';
  }

  // Считаем итого смен по сотруднику
  function totalShifts(empId) {
    let total = 0;
    days.forEach(day => {
      const val = grid[`${empId}_${day}`];
      if (val && val !== 'х' && !['н','с','д','дст','нст','сст','замд','замн','замс','0.5'].includes(val)) total += parseFloat(val) || 0;
      if (['н','с','д','дст','нст','сст','замд','замн','замс'].includes(val)) total += 1;
      if (val === '0.5') total += 0.5;
    });
    return total || '';
  }

  return (
    <div className="pt-page" onClick={() => setPopup(null)}>
      <div className="pt-header">
        <h2>Табель смен</h2>
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
          <select value={month} onChange={e => setMonth(parseInt(e.target.value))} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }}>
            {MONTHS.map((m,i) => <option key={i} value={i}>{m}</option>)}
          </select>
          <select value={year} onChange={e => setYear(parseInt(e.target.value))} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }}>
            {[2024,2025,2026,2027].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <select value={selectedHotel} onChange={e => { setHotel(e.target.value); setDept(''); }} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14, minWidth:220 }}>
            <option value="">— выберите объект —</option>
            <optgroup label="Отели">
              {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
            </optgroup>
            {depts.length > 0 && (
              <optgroup label="Подразделения">
                {depts.map(d => <option key={'d'+d.id} value={''}  onClick={() => { setDept(d.id); setHotel(''); }}>{d.name}</option>)}
              </optgroup>
            )}
          </select>
          <button
            className="btn-secondary"
            onClick={() => window.open(`/api/payroll/export/schedule-month?year=${year}&month=${month + 1}`, '_blank')}
            title="Выгрузить табель всех отелей за месяц"
          >
            📥 Выгрузить все
          </button>
        </div>
      </div>

      {!selectedHotel && !selectedDept ? (
        <div style={{ textAlign:'center', padding:60, color:'#9ca3af', background:'#fff', borderRadius:12 }}>
          Выберите отель или подразделение
        </div>
      ) : loading ? (
        <div style={{ textAlign:'center', padding:60, color:'#9ca3af' }}>Загрузка...</div>
      ) : (
        <>
          <div className="shift-legend">
            {SHIFT_OPTIONS.filter(o => o.value).map(o => (
              <span key={o.value} className="shift-legend-item" style={{ background: o.color, color: o.text }}>
                {o.label}
              </span>
            ))}
            <span style={{ fontSize:12, color:'#9ca3af', marginLeft:8 }}>· выходные дни выделены серым</span>
            <button
              onClick={() => setShowLegend(v => !v)}
              style={{ marginLeft:'auto', background:'none', border:'1px solid #e5e7eb', borderRadius:8, padding:'4px 12px', fontSize:12, color:'#6b7280', cursor:'pointer' }}
            >
              📖 Расшифровка смен
            </button>


          </div>

          {showLegend && (
            <div style={{
              background:'#fff', border:'1px solid #e5e7eb', borderRadius:12,
              padding:16, marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.08)'
            }}>
              <div style={{ fontWeight:600, fontSize:13, color:'#374151', marginBottom:12 }}>Типы смен</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px 24px' }}>
                {SHIFT_OPTIONS.filter(o => o.value && o.hint).map(o => (
                  <div key={o.value} style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ background: o.color || '#f3f4f6', color: o.text || '#374151', padding:'2px 10px', borderRadius:20, fontSize:11, fontWeight:700, minWidth:44, textAlign:'center', flexShrink:0 }}>{o.label}</span>
                    <span style={{ fontSize:12, color:'#374151' }}>{o.hint}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="shift-grid-wrap">
            <table className="shift-grid">
              <thead>
                <tr>
                  <th className="shift-name-col">Сотрудник</th>
                  {days.map(d => (
                    <th key={d} className={`shift-day-col ${isWeekend(d) ? 'weekend' : ''}`}>
                      <div>{d}</div>
                      <div className="shift-day-name">{getDayName(d)}</div>
                    </th>
                  ))}
                  <th className="shift-total-col">Итого</th>
                </tr>
              </thead>
              <tbody>
                {employees.length === 0 && (
                  <tr><td colSpan={daysInMonth+2} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Сотрудники не найдены</td></tr>
                )}
                {groupedEmployees.map(group => (
                  <React.Fragment key={group.key}>
                    <tr>
                      <td
                        colSpan={daysInMonth+2}
                        style={{ background:'#f1f5f9', padding:'6px 12px', fontSize:11, fontWeight:700, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.08em', borderBottom:'1px solid #e2e8f0' }}
                      >
                        {group.label} ({group.emps.length})
                      </td>
                    </tr>
                    {group.emps.map(emp => (
                      <tr key={emp.id}>
                        <td className="shift-name-cell">
                          <div style={{ fontWeight:600, fontSize:13, color:'#111827', lineHeight:'1.4' }}>{String(emp.full_name || '—')}</div>
                          <div style={{ fontSize:11, color:'#9ca3af', lineHeight:'1.4' }}>{String(emp.position || '')}</div>
                        </td>
                        {days.map(day => {
                          const key = `${emp.id}_${day}`;
                          const val = grid[key] || '';
                          return (
                            <td
                              key={day}
                              className={`shift-cell ${isWeekend(day) ? 'weekend' : ''}`}
                              style={getCellStyle(val)}
                              onClick={e => cellClick(e, emp.id, day)}
                              title="Кликните для изменения"
                            >
                              {getCellLabel(val)}
                            </td>
                          );
                        })}
                        <td className="shift-total-cell">{totalShifts(emp.id)}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {popup && (
            <div
              className="shift-popup"
              style={{ position:'fixed', left: Math.min(popup.x, window.innerWidth-240), top: Math.min(popup.y, window.innerHeight-300), zIndex:1000, minWidth: isAdmin ? 220 : 120 }}
              onClick={e => e.stopPropagation()}
            >
              <div style={{ padding:'6px 12px', fontSize:11, color:'#9ca3af', borderBottom:'1px solid #f3f4f6', fontWeight:600 }}>
                {popup.day}.{String(month+1).padStart(2,'0')}.{year}
              </div>
              {SHIFT_OPTIONS.map(o => (
                <div
                  key={o.value}
                  className="shift-popup-item"
                  style={o.color ? { background: o.color, color: o.text } : {}}
                  onClick={() => setShift(popup.empId, popup.day, o.value)}
                >
                  <span style={{ fontWeight:600 }}>{o.label || 'очистить'}</span>
                  {o.hint && <span style={{ fontSize:10, opacity:0.75, marginLeft:6 }}>{o.hint}</span>}
                </div>
              ))}
              {isAdmin && history && (
                <div style={{ borderTop:'1px solid #f3f4f6', padding:'8px 12px' }}>
                  <div style={{ fontSize:11, color:'#9ca3af', fontWeight:600, marginBottom:4 }}>ИСТОРИЯ</div>
                  {history.loading && <div style={{ fontSize:11, color:'#9ca3af' }}>Загрузка...</div>}
                  {!history.loading && history.shifts.length === 0 && (
                    <div style={{ fontSize:11, color:'#9ca3af' }}>Нет записей</div>
                  )}
                  {!history.loading && history.shifts.map(s => (
                    <div key={s.id} style={{ fontSize:11, color:'#374151', marginBottom:2, display:'flex', justifyContent:'space-between', gap:8 }}>
                      <span>{s.shift_count > 0 ? `${s.shift_count} см` : s.note || '—'}</span>
                      <span style={{ color:'#9ca3af' }}>{new Date(s.created_at).toLocaleString('ru', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
